<template>
    <v-card>
        <v-card-title>
            <h2>Fields</h2>
        </v-card-title>
        <v-card-text>
            <ul v-if="fields.length > 0">
                <li
                    v-for="(field, id) in fields"
                    :key="id"
                >
                    <router-link :to="'/field/edit/' + field.id ">
                        {{ field.name }}
                    </router-link>
                </li>
            </ul>
            <p v-else>
                <span>
                    This card contains no fields.
                </span>
            </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn to="/field/create">
                <v-icon
                    left
                    small
                >
                    fas fa-plus-circle
                </v-icon>
                Add Field
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('cardEditor', ['name', 'section', 'fields'])
    }
};
</script>
